import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery, Toolbar } from '@mui/material';
import Header from './Header';
import Sidebar from './Sidebar';
import IBKRSidebar from '../ibkr/IBKRSidebar';
// VersionBadge wird global in ``App.tsx`` gemounted, damit er auch auf
// oeffentlichen Routen (Login, Register, Forgot-Password) sichtbar ist.

const DRAWER_WIDTH = 200;

interface AppShellProps {
  children: React.ReactNode;
  mode?: 'bitvavo' | 'ibkr';
  onModeChange?: (mode: 'bitvavo' | 'ibkr') => void;
}

const AppShell: React.FC<AppShellProps> = ({ children, mode = 'bitvavo', onModeChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <Header
        onMenuToggle={() => setSidebarOpen(p => !p)}
        mode={mode}
        onModeChange={onModeChange}
      />
      {mode === 'ibkr' ? (
        <IBKRSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      ) : (
        <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      )}

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'hidden',
          backgroundColor: 'background.default',
          minHeight: '100vh',
        }}
      >
        <Toolbar />
        <Box sx={{ p: 3 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default AppShell;
